import {Component, OnInit} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';


import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ApiFormService} from './service/api-form.service';

import Swal from 'sweetalert2';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})


export class AppComponent implements OnInit {
  title: any = 'Solicitud de Producto';
  nameButton: any = 'Enviar';
  public formGroup: FormGroup;
  submitted = false;

  constructor(private  formBuilder: FormBuilder, public http: HttpClient, private  apiFormService: ApiFormService) {

  }
  ngOnInit() {

    this.formGroup = this.formBuilder.group({
      name: ['', [Validators.required, Validators.minLength(3), Validators.pattern(/^[A-Za-zñÑáéíóúÁÉÍÓÚ\s]+$/)]],
      phone: ['', [Validators.required, Validators.pattern(/^[0-9]+$/), Validators.minLength(8), Validators.maxLength(8)]]
    });
  }


  get f() { return this.formGroup.controls; }



  onSubmit() {
    this.submitted = true;
    const form = 2;
    const user = this.formGroup.value;
    const email = '';
    if (this.formGroup.valid) {
      ( document.getElementById('btn-save') as HTMLInputElement).disabled = true;
      this.nameButton = 'Enviando';
      this.apiFormService.postFormSave( user.name, user.phone, email, form).subscribe(
          result => {
            if (result === 2 || result === 3) {
              Swal.fire({
                type: 'error',
                title: 'Error en el envio de datos...'
              });
              this.formGroup.reset();
              Object.keys(this.formGroup.controls).forEach(key => {
                this.formGroup.controls[key].setErrors(null);
              });

            } else if (result === 1) {
              Swal.fire({
                type: 'success',
                title: 'Gracias por registrarse, \n Nos estaremos comunicando de 2 a 7 minutos.',
                showConfirmButton: true,
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#dd141d'
              });
              this.formGroup.reset();
              Object.keys(this.formGroup.controls).forEach(key => {
                this.formGroup.controls[key].setErrors(null);
              });
            } else if (result === 4) {
              Swal.fire({
                type: 'success',
                title: 'Gracias por registrarse, \n Nos estaremos comunicando muy pronto.',
                showConfirmButton: true,
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#dd141d'
              });
              this.formGroup.reset();
              Object.keys(this.formGroup.controls).forEach(key => {
                this.formGroup.controls[key].setErrors(null);
              });
            }
          },
          error => {
            Swal.fire({
              type: 'error',
              title: 'Error API.'
            });
            this.formGroup.reset();
            Object.keys(this.formGroup.controls).forEach(key => {
              this.formGroup.controls[key].setErrors(null);
            });
          });
      this.nameButton = 'Enviar';
    } else if (this.formGroup.invalid) {
      return;
    }

  }


}
